<template>
  <div id="app" name="app" ref="app">
    <!-- 顶栏容器 -->
    <div class="header">
      <TopNav></TopNav>
    </div>
    <!-- 顶栏容器END -->
    <div class="main-div">
      <!-- 主要区域容器 -->
      <div class="main">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
      <!-- 主要区域容器END -->
      <!-- 底栏容器 -->
      <div class="footer" id="footer">
        <BotFooter></BotFooter>
      </div>
    </div>

    <el-backtop :visibility-height="100" :bottom="120" style="width: 50px;height: 50px;">
      <div class="back-up">
        <img src="https://blhc806.oss-cn-hangzhou.aliyuncs.com/wmUsImg/sysImg/up_btn_top.png" alt="">
      </div>
    </el-backtop>
    <el-drawer :visible.sync="drawer" direction="btt" :show-close="false" :wrapperClosable="false" :withHeader="false"
      custom-class="cookie-drawer-auto">
      <CookieMain @close="closeCookieDrawer"></CookieMain>
    </el-drawer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CookieMain from "@/components/cookie.vue";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      currentScroll: 0,
      iframeUrl: `https://www.zz4life.com/item/wm/usChatTest/index.html`,
      dialogVisible: true,
      isRouter: false,
      drawer: false,
    };
  },
  components: {
    CookieMain,
  },
  computed: {
    ...mapGetters(["getIframeVisible"]),
  },
  watch: {
    getIframeVisible(val) {
      this.dialogVisible = val;
    },
    '$route.path'() { // 去掉未使用的 newPath 参数
      this.updateRouterState();
    },
  },
  mounted() {
    this.checkCookieConsent(); // 检查是否需要展示 Cookie 栏
    this.updateRouterState(); // 初始化路由状态
    // let isMobile =
    //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //     navigator.userAgent
    //   );
    window.addEventListener('resize', this.updateWidth);
    // if (isMobile) {
    //   // console.log("Mobile");
    //   // window.location.href = "http://192.168.10.183:8080";
    //   // window.location.href = "https://www.alyhomeus.com/mobile/";
    //   return;
    // } else {
    //   // console.log("pc");
    //   return;
    // }
  },
  beforeDestroy() {
    // 销毁时移除监听
    window.removeEventListener('resize', this.updateWidth);
  },
  methods: {
    updateWidth() {
      const width = document.documentElement.clientWidth || window.innerWidth;
      // 提交到 Vuex
      this.$store.commit('app/SET_SCREEN_WIDTH', width);
    },
    checkCookieConsent() {
      // 检查是否存在名为 'aly_cookie_status' 的标记
      const status = Cookies.get("aly_cookie_status");
      if (!status) {
        // 如果没有标记，说明是首次访问或 Cookie 已过期
        this.drawer = true;
      } else {
        // 如果有标记，不再展示
        this.drawer = false;
      }
    },
    closeCookieDrawer() {
      this.drawer = false;
    },
    updateRouterState() {
      // 当路由为 /、/home 或 /contact 时，isRouter 为 false，否则为 true
      const currentPath = this.$route.path.toLowerCase();
      this.isRouter = !(currentPath === '/' || currentPath === '/home' || currentPath === '/contact');
    },
    openOnline() {
      this.$store.commit("showIframe", true);
    },
    openCart() {
      this.$router.push('/shoppingCart')
    }
  },
};
</script>

<style lang="scss">
/* 全局CSS */
.el-loading-spinner i,
.el-loading-spinner .el-loading-text {
  color: #5a4a42 !important;
  /* 修改文字颜色 */
}

.el-loading-spinner i {
  font-size: 30px !important;
}

* {
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  list-style: none;
}



/* 隐藏默认滚动条 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
}

page,
html,
body {
  width: 1920px;
}


@font-face {
  font-family: "NotoSerif";
  src: url("./assets/NotoSerif-VariableFont_wdth.ttf") format("truetype");
}

body {
  font-family: "NotoSerif", sans-serif;
}

button {
  font-family: "NotoSerif", sans-serif;
}

.header {
  width: 1920px;
  padding: 0;
  position: sticky;
  left: 0;
  right: 0;
  top: 0;
  // background-color: #fff;
  z-index: 1001;
}

.main-div {
  width: 100%;
  padding: 0;
  position: relative;
  left: 0;
  top: 0;
}

.main {
  width: 100%;
  padding: 0;
}

.footer {
  width: 100%;
  padding: 0;
}

a,
a:hover {
  text-decoration: none;
}

ul>li {
  display: flex;
  align-items: center;
}

.online-part {
  width: 388px;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  padding: 0 16px 0 13px;
  box-sizing: border-box;
  cursor: pointer;
  background-color: #74c9c6;
  border-radius: 10px 10px 0 0;
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 99;
}

.all-page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 88;
}

.iframe-visible {
  /* width: 368px; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 10px;
  bottom: 10px;
  border-radius: 30px 30px 0 0;
  overflow: hidden;
  background-color: transparent;
  z-index: 99;
}

.iframe-icon {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  right: 30px;
  top: 20px;
  cursor: pointer;
}

.back-up {
  color: #caa68a;
  text-align: center;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-up img {
  width: 24px;
  height: 24px;
}

.cart {
  position: fixed;
  right: 40px;
  bottom: 560px;
  background-color: #FFF;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  cursor: pointer;
  z-index: 5;
}

.cart-num {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 14px;
  height: 14px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  background-color: #f00;
  color: #fff;
  font-size: 12px;
  font-family: math;
}

.el-drawer__wrapper {

  /* 针对底部抽屉的重置 */
  .cookie-drawer-auto {
    height: auto !important;
    /* 强制高度自动 */
    max-height: 80vh;
    /* 可选：防止内容过多超出屏幕 */
    min-height: 150px;
    /* 可选：设置一个最小高度 */

    .el-drawer__body {
      height: auto;
      /* 内部容器也设为自动 */
      overflow: visible;
      /* 允许内容撑开 */
    }
  }
}

input::placeholder {
  font-family: "NotoSerif", serif !important;
}

@media screen and (max-width:768px) {
  page,
  html,
  body {
    width: 100% !important;
  }

  .header {
    width: 100% !important;
  }

  .back-up img {
    width: 80px;
    height: 80px;
  }
  .el-message-box{
    width: auto !important;
  }

}

/* 全局CSS END */
</style>
